import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../index';

// Базовые селекторы
const selectMapState = (state: RootState) => state.map;

// Мемоизированные селекторы для фильтров (предотвращают лишние ре-рендеры)
export const selectMapFilters = createSelector(
    [selectMapState],
    (mapState) => ({
        isTrafficVisible: mapState.isTrafficVisible,
        isDpsMarkersVisible: mapState.isDpsMarkersVisible,
        isWebcamsMarkersVisible: mapState.isWebcamsMarkersVisible,
        isCleanMarkersVisible: mapState.isCleanMarkersVisible,
        isDtpMarkersVisible: mapState.isDtpMarkersVisible,
    })
);

// Селекторы для отдельных фильтров
export const selectIsDpsMarkersVisible = createSelector(
    [selectMapState],
    (mapState) => mapState.isDpsMarkersVisible
);

export const selectIsWebcamsMarkersVisible = createSelector(
    [selectMapState],
    (mapState) => mapState.isWebcamsMarkersVisible
);

export const selectIsCleanMarkersVisible = createSelector(
    [selectMapState],
    (mapState) => mapState.isCleanMarkersVisible
);

export const selectIsDtpMarkersVisible = createSelector(
    [selectMapState],
    (mapState) => mapState.isDtpMarkersVisible
);

export const selectIsTrafficVisible = createSelector(
    [selectMapState],
    (mapState) => mapState.isTrafficVisible
);

export const selectIsFiltersLoaded = createSelector(
    [selectMapState],
    (mapState) => mapState.isFiltersLoaded
);

// Селектор для данных карты
export const selectMapData = createSelector(
    [selectMapState],
    (mapState) => ({
        selectedCity: mapState.selectedCity,
        mapToken: mapState.mapToken,
        events: mapState.events,
        webcams: mapState.webcams,
        userPremium: mapState.userPremium,
        isMapReady: mapState.isMapReady,
    })
);

// Селектор для настроек города (предотвращает лишние ре-рендеры)
export const selectCitySettings = createSelector(
    [selectMapState],
    (mapState) => mapState.selectedCity?.settings
);
